import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

// base.cssが優先されてしまうため&[type="text"]を指定する
export const dateInputStyle = css`
  &[type="text"] {
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    padding-left: 12px;
    padding-right: 32px;
    background: #ffffff;
    font-size: 14px;
    font-family: inherit;
    &::placeholder {
      color: #a3a3a3;
      font-size: 14px;
    }

    border: 1px solid #00000014;
  }
`;

export const inputContainerStyle = css`
  height: 32px;
  position: relative;

  ${MEDIA_QUERY_FOR_PC} {
    width: 156px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
  }
`;

export const iconStyle = css`
  bottom: 0;
  margin-block: auto;
  position: absolute;
  right: 0;
  top: 0;
  color: #000;
  pointer-events: none;

  ${MEDIA_QUERY_FOR_PC} {
    height: 14px;
    margin-right: 11px;
    width: 14px;
  }
  ${MEDIA_QUERY_FOR_SP} {
    height: 10px;
    margin-right: 8px;
    width: 10px;
  }
`;

export const backdropStyle = css`
  position: fixed;
  inset: 0;
  background-color: transparent;
  z-index: 1000;
`;

export const calendarContainerStyle = css`
  bottom: 0;
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
  right: 0;
  z-index: 1010;

  ${MEDIA_QUERY_FOR_PC} {
    height: 396px;
    width: 426px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    height: 312px;
    width: 336px;
  }
`;

export const calendarContainerLeftPositionStyle = css`
  ${MEDIA_QUERY_FOR_PC} {
    transform: translateX(-40%);
  }

  ${MEDIA_QUERY_FOR_SP} {
    transform: translateX(-3%);
  }
`;

export const calendarContainerRightPositionStyle = css`
  ${MEDIA_QUERY_FOR_SP} {
    transform: translateX(3%);
  }
`;
